import shapes from './Shape';
import svgs from './svgs';

export enum SocialNetworks {
    FACEBOOK = 'facebook',
    STEAM = 'steam',
    VK = 'vk'
}

export const SocialColors = {
    [SocialNetworks.FACEBOOK]: {
        PRIMARY: '#1C3578',
        SECONDARY: '#334985'
    },
    [SocialNetworks.VK]: {
        PRIMARY: '#4E74A0',
        SECONDARY: '#6B8CB3'
    },
    [SocialNetworks.STEAM]: {
        PRIMARY: '#1D1D1D',
        SECONDARY: '#232323'
    }
};

export const LINK_ACCOUNTS_SOCIAL_NETWORKS = [
    SocialNetworks.FACEBOOK,
    SocialNetworks.VK,
    SocialNetworks.STEAM
];

export const LinkAccountIcons = {
    [SocialNetworks.FACEBOOK]: {
        icon: svgs.FACEBOOK,
        backgroundColor: '#1C3578',
        type: shapes.ROUND
    },
    [SocialNetworks.VK]: {
        icon: svgs.VK,
        backgroundColor: '#5181B8',
        type: shapes.ROUND
    },
    [SocialNetworks.STEAM]: {
        icon: svgs.STEAM_ROUND
    }
};

export const SuggestedFriendsIcons = {
    [SocialNetworks.FACEBOOK]: {
        icon: svgs.FACEBOOK,
        backgroundColor: 'transparent',
        type: shapes.ROUND
    },
    [SocialNetworks.VK]: {
        icon: svgs.VK,
        backgroundColor: 'transparent',
        type: shapes.ROUND
    },
    [SocialNetworks.STEAM]: {
        icon: svgs.STEAM
    }
};

// @depreciated - export enums directly
export const SOCIAL_NETWORKS = SocialNetworks;
export const SOCIAL_COLORS = SocialColors;
export const LINK_ACCOUNT_ICONS = LinkAccountIcons;
export const SUGGESTED_FRIENDS_ICONS = SuggestedFriendsIcons;

export default {
    SOCIAL_NETWORKS: SocialNetworks,
    SOCIAL_COLORS: SocialColors,
    LINK_ACCOUNTS_SOCIAL_NETWORKS,
    LINK_ACCOUNT_ICONS: LinkAccountIcons,
    SUGGESTED_FRIENDS_ICONS: SuggestedFriendsIcons
};
